export const formatCurrency = (equationElement, currency) => {
    const formattedCurrency = currency === 'h' ? `${equationElement}${currency}` : `${currency}${equationElement}`;

    return formattedCurrency;
}